var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStory6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 133,
    viewBox: "0 0 357 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 132.5L356.058 109.765L334.34 117.618L352 132.5ZM0.557029 4.49877C50.2272 3.08187 125.033 7.215 193.036 23.7213C227.036 31.9742 259.257 43.3016 285.764 58.5218C312.278 73.7452 332.949 92.7882 344.069 116.421L347.688 114.718C336.102 90.0951 314.697 70.5219 287.756 55.053C260.81 39.581 228.198 28.1402 193.98 19.8342C125.545 3.22297 50.3679 -0.923771 0.442971 0.500395L0.557029 4.49877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory6);
export default __webpack_public_path__ + "static/media/story6.c290c8e0806f9d8f41365f37a460f40b.svg";
export { ForwardRef as ReactComponent };